module.exports = __webpack_public_path__ + "static/media/BG1.198bd5fc.png";